// extracted by mini-css-extract-plugin
module.exports = {"uploadBtnWrapper":"chat_uploadBtnWrapper__pVB-M","btn":"chat_btn__D8Trv","customBadge":"chat_customBadge__3w1od"};